import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce, useSelect, useViewport } from '@chilecompra/react-kit'
import { Card, DataTable, Select } from '@chilecompra/react-kit/components'
import IconButton from '../../components/Buttons/IconButton'
import { exportToCsv } from '../../modules/utils/exports'
import { OPTION_ALL } from '../../config/settings/constants'
import { onGetBuyersThunk } from './BuyersList.actions'
import { Content, GridContainer, Link, Root, TextDownload } from './BuyersList.styles'

/**
 * The BuyersList's container.
 */
const BuyersList = () => {
  const dispatch = useDispatch()
  const { data, loading } = useSelector(state => state.buyersList)
  const { sectors } = useSelector(state => state.topNavbar)
  const {
    size: { isUpToMedium }
  } = useViewport()
  const options = sectors?.map(sector => ({
    name: sector.name,
    value: sector.value
  }))
  const [filteredData, setFilteredData] = useState([])

  const {
    error: sectorError,
    value: sectorValue,
    onChange: handleChangeSector
  } = useSelect({
    initialValue: OPTION_ALL,
    changeCallback: updatedValue =>
      setFilteredData(updatedValue === OPTION_ALL ? data : data?.filter(datum => datum[3] === updatedValue))
  })

  const downloadCsv = () => {
    const csv = [['Nombre de la institución', 'Sector', 'Código', 'Id. Sector'], ...filteredData]
    exportToCsv(csv, 'Listado organismos compradores')
  }

  useEffectOnce(() => {
    dispatch(onGetBuyersThunk())
  })

  useEffect(() => {
    setFilteredData(data)
  }, [data])

  return (
    <Root>
      <Content>
        <Card color="blank" elevation="1" margin={isUpToMedium ? '48px 0 128px' : '48px 0'}>
          <DataTable
            footer={
              <GridContainer alignItems="center">
                <IconButton disabled={loading} type="download" onClick={downloadCsv}>
                  <TextDownload>DESCARGAR DATOS</TextDownload>
                </IconButton>
              </GridContainer>
            }
            header={
              <GridContainer md={3} xs={12}>
                <Select
                  error={sectorError}
                  label="SECTOR DEL ESTADO"
                  onChange={handleChangeSector}
                  options={options?.reverse() || []}
                  value={sectorValue}
                />
              </GridContainer>
            }
            headers={[
              { label: 'Nombre', value: 0 },
              { label: 'Sector', value: 1 }
            ]}
            headersCellsProps={[
              { enableFilter: true, enableSort: true, width: '60%' },
              { enableFilter: true, enableSort: true, width: '40%' }
            ]}
            loading={loading}
            records={filteredData}
            recordsDecorators={[
              ([name, , id]) => <Link to={`/ficha-organismo/${id}`}>{name}</Link>,
              ([, sector]) => sector
            ]}
          />
        </Card>
      </Content>
    </Root>
  )
}

export default BuyersList
